import React, { useCallback, useMemo, useState } from 'react';
import { useMutation } from '@apollo/client';
import { useToast } from '@hooks/toast.hook';
import { AlertModal } from '@components/Modal';
import { Console, getRoute } from '@utils';
import {
  SuggestionEmailParams,
  SuggestionEmailResponse,
  SendSuggestionEmail,
} from '@queries/user/mutations';
import { useRouter } from 'next/router';
import { SuggestionsForm } from '@components/forms';
import { BackgroundGlobalStyle } from '@components/PageWrapper';
import { useWindowSize } from '@hooks/useWindowSize';
import { Header } from '@components/Header/Header';
import { Container } from './styles';
import { Suggestion } from '@interfaces';

const TAG = '[SUGGESTIONS_EMAIL_SCREEN]';

export function SuggestionEmail() {
  // Hooks init
  const { showToast } = useToast();
  const { push, pathname } = useRouter();

  const [sendSuggestion, { loading }] = useMutation<
    SuggestionEmailResponse,
    SuggestionEmailParams
  >(SendSuggestionEmail());

  // Local State
  const [open, setOpen] = useState<boolean>(false);

  // Logic
  const handleSubmit = useCallback(
    async (suggestionInfo: {
      name: string;
      email: string;
      comment: string;
      origin: Suggestion['origin'];
    }) => {
      try {
        await sendSuggestion({
          variables: {
            params: {
              name: suggestionInfo.name,
              email: suggestionInfo.email,
              comment: suggestionInfo.comment,
              origin: suggestionInfo.origin,
            },
          },
        });
        setOpen(true);
      } catch (e) {
        showToast({
          message: `Ups, ha ocurrido un error. Intente denuevo`,
          type: 'error',
        });
      }
    },
    [sendSuggestion, showToast],
  );
  const size = useWindowSize();
  const desktop = useMemo(() => {
    if (!size.width) return true;
    return size.width > 900;
  }, [size.width]);
  return (
    <>
      <BackgroundGlobalStyle mobileColor="gray" />
      <Header hasSearchBox />
      <Container>
        <SuggestionsForm handleFormSubmit={handleSubmit} loading={loading} />
      </Container>
      <AlertModal
        title={'Comentarios enviados'}
        content={`Te contactaremos durante las próximas horas.
                  Gracias por ayudarnos a mejorar.`}
        open={open}
        setOpen={setOpen}
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        actions={[
          {
            text: 'OK',
            onActionClick: () => {
              Console.log(
                TAG + 'onActionClick: Suggestion send confirmation, pushing to',
                {
                  pushTo: getRoute('allSuggestions').pathname,
                  from: pathname,
                },
              );
              return push(getRoute('allSuggestions'));
            },
            variant: 'contained',
          },
        ]}
      />
    </>
  );
}
